import React from 'react'
import Col from 'react-bootstrap/Col';
import './Engineering.css'

const Engineering = () => {
  return (
    <div>
      <br/>
      <h1 className='head1' style={{
            color:"#0072F9",
         }}
        >Engineering Success</h1>
      <br/>

      <Col md={{offset:1}}>
      <h2 className='head2' style={{
            color:"#0072F9",
         }}
        >Origins</h2>
      </Col>
      <Col md={{span:8,offset:1}}>
       <p>As an important tool in synthetic biology research, gene editing with its safety issue in application is of great importance. Through human practice and preliminary research, we attached our concentration on how to improve the safety of gene editing and further develop tools relating to this topic. Eventually, the Anti-CRISPR protein caught our attention.</p>
      </Col>


      
      <Col md={{offset:1}}>
      <h2 className='head2' style={{
            color:"#0072F9",
         }}
        >Design</h2>
      </Col>
      <Col md={{span:8,offset:1}}>
       <p>In 2013, it is the first time for scientists to discover the phenomenon of anti-CRISPR in the phage of Pseudomonas aeruginosa, therefore the anti-CRISPR protein began to showed up in front of biologists. It has brought a breakthrough in gene editing, as anti-CRISPR proteins are not only used to suppress off-target effects and thus improve the safety of synthetic biology experiments but also as inhibitors of gene editing regulation, and can be used to modify proteins, providing synthetic biologists with more alternative tools for experimental design. We found that these proteins were of huge potential for usability and signification for research. Currently, with many discoveries in the field of viral macro-genomics and rapid explosion of prokaryotic genomic data, it is highly possible that many novel anti-CRISPR proteins, potential tools for gene editing regulation, will be generated by the arms race in virus and bacteria evolution. This fact leads to our belief that the research for novel anti-CRISPR proteins is a very promising and valuable project that could provide more usable tools for synthetic biology in the future.</p>
      <p>
      Initially, our software is designed to provide a tool that can search the  consistently expanding databases of viral genomes, macro genomes, and other MGEs for novel Anti-CRISPR proteins, thus increasing the diversity of Anti-CRISPR proteins and possibility of discovering other defense systems with repression functions. It could provide a simple and convenient way to mine potential Anti-CRISPR proteins.</p>
      <p>
        Our design proposal is as follows.
      </p>

      <img src="https://static.igem.wiki/teams/4272/wiki/process.png" alt="process" id="process"
        style={{width:'100%'}}>
      </img>

      <p>
      Our software hopes to use the sequence information of the input genome to predict whether there are potential Acr proteins in it, through the process of extracting the encoded proteins from the genome, calculating protein-related features, and using our pre-built models.  </p>
      </Col>
      
      <Col md={{offset:1}}>
      <h2 className='head2' style={{
            color:"#0072F9",
         }}
        >Build</h2>
      </Col>
      <Col md={{span:8,offset:1}}>
      <p>
      In our project, model construction is a very critical part. Our initial model-building process is : </p>

      <p>
      (1) We collected information about the genome where the existing Acr proteins are located from the anti-CRISPRdb data, then collected representative Acr proteins and non-Acr proteins from it as the training set. </p>
      <p>
      (2) For the features required for model construction, we selected a series of protein properties such as hydrophobicity, length, and genomic features including lysogenic viral boundaries, self-targeting CRISPR systems, etc.  </p>  
      <p>
      (3) We planned to train a classification model to predict acr proteins  </p>
      <br/>
      </Col>


      <Col md={{offset:1}}>
      <h2 className='head2' style={{
            color:"#0072F9",
         }}
        >Test & Re-design</h2>
      </Col>
      <Col md={{span:8,offset:1}}>
       <p>
        And in the process of model testing, we found a series of problems that we need to solve.
      </p>
    

      <h4 className='head4' style={{
            color:"#0072F9",
         }}
        >Problem 1: Too many features and redundant information</h4>
      <p>
      Since we introduced features such as lysogenic virus boundary and self-targeting CRISPR system, after collating data, we found that the matrix of such features was sparse and only a small portion of species existed with similar features, which were not significant for the final decision.</p>
      <Col md={{offset:0}}>
      <h4 className='head4' style={{
            color:"#0072F9",
         }}
        ><img src={require("../../../src/assets/arrow-right.png")} alt="a" style={{height:"50px"}} />
        Redesign 1: Introduction of concept "directon"[1]</h4></Col>
         <p>
         After reviewing relevant information and communicating with other teams, we introduced the "directon" feature to aid in decision-making. This feature is based on Acr protein around Aca protein to assist in prediction, and we used a series of concepts generating from this feature, which is of huge importance in our prediction model. </p>

      <h4 className='head4' style={{
            color:"#0072F9",
         }}
        >Problem 2: Unbalanced data ratio</h4>
        <p>
        The percentage of positive data in our data was very low (lower than or equal 2%). Meanwhile we firstly thought that training the model directly would result in a very low false positive rate, and all the proteins found would have a very high probability of being actual ACR proteins. But the fact is that almost no protein was found.</p>
        <Col md={{offset:0}}>
      <h4 className='head4' style={{
            color:"#0072F9",
         }}
        ><img src={require("../../../src/assets/arrow-right.png")} alt="a" style={{height:"50px"}} />
         Redesign 2: Data Processing</h4></Col>
      <p>
      We referred to the random forest approach to do out-of-bag put-back sampling each round to construct almost balanced training sets to optimize the model and achieved good results.</p>
         <p>In addition, through communication with the SYSU team, we found that they also encountered the same problem, and their data processing method also provided us with some references and inspired us to use the downsampling method to process the data.</p>
        <h4 className='head4' style={{
            color:"#0072F9",
         }}
        >Problem 3: Model selection</h4>
        <p>
        We were tangled with the choice of models among convolutional neural network, SVM, random forest, and other methods, and found that the comparability was not high after completing several tests of building individual models. This also prevented us from obtaining a model with better results and brought our project progress to a deadlock.</p>
        <Col md={{offset:0}}>
        
        <h4 className='head4' style={{
            color:"#0072F9",
         }}
        ><img src={require("../../../src/assets/arrow-right.png")} alt="a" style={{height:"50px"}} />
          Redesign 3: Grid Search</h4></Col>
       <p>
       To get the optimal results for each model, we reviewed the data and solved the problem by continuously trying different methods. Finally, we found the grid search method. Through this method, we compared the results of different models and determine the random forest algorithm as the core discriminant algorithm of the model, which also resulted in the excellent prediction output of our model.</p>
      </Col>
      
      <Col md={{offset:1}}>
      <h2 className='head2' style={{
            color:"#0072F9",
         }}
        >Re-Build</h2>
      </Col>
      <Col md={{span:8,offset:1}}>
       <p>Through repeating such processes: having a try, learning and discussing, improving project design ......, we developed our final model. In this model, we finally decided to use feature information from the genome based on the concept of direction while calculating protein properties. After feature selecting, we applied the Random Forest algorithm and achieved good performance. The details can be found in the Modeling.</p>
      </Col>

      <Col md={{offset:1}}>
      <h2 className='head2' style={{
            color:"#0072F9",
         }}
        >Improve</h2>
      </Col>
      <Col md={{span:8,offset:1}}>
       <p> 
       After the software was completely developed, we found that the input format for the genome could be improved after delivering user testing, which could be seen in the Human Practices section. Initially, we originally specified the fasta format for input format, but user feedback demonstrated that input specification was not suitable for batch processing. So, we added the NCBI Accession Number input format to enhance its usability. </p>
      <p>
      In addition, we have improved the code to reduce the running time considering the user feedback that reveals the speed issue of the software. In addition, in order to increase the convenience of our software, we have reduced the input to a minimum, requiring only the genome number or sequence to complete the prediction without specifying additional information such as species, calculation method, etc.</p>
      </Col>


      <Col md={{offset:1}}>
      <h2 className='head2' style={{
            color:"#0072F9",
         }}
        >Validation</h2>
      </Col>
      <Col md={{span:8,offset:1}}>
       <p> 
       Finally, we validated the prediction output of our software, which consists of sub-sections including independent testing set evaluation, proof of concept, comparison of similar software results, and molecular docking. The details are described in the Validation page. Although our validation results did not perform well at first, they are gradually improved by our optimization.</p>
      <p>
        All in all, our final validation results indicate that we succeed in predicting the potential Acr proteins in the genome easily and efficiently, confirming the outstanding feasibility of our software. </p>
      </Col>




      <Col md={{offset:1}}>
      <h2 className='head2' style={{
            color:"#0072F9",
         }}
        >Reference</h2>
      </Col>
      <Col md={{span:8,offset:1}}>
       <p> 
       [1] Gussow, A.B., Park, A.E., Borges, A.L. et al. Machine-learning approach expands the repertoire of anti-CRISPR protein families. Nat Commun 11, 3784 (2020). https://doi.org/10.1038/s41467-020-17652-0
       </p>
      </Col>

    </div>
  )

}

export default Engineering